<div class="bg-dark w-screen h-screen overflow-hidden text-white">
  <router-outlet></router-outlet>
</div>
